export default {
    get_research: state => { return state.launch_research},
    get_reset_product_list: state => { return state.reset_product_list},
    get_fmotc_typ: state => { return state.fmotc_typ},
    get_fmotc_mat: state => { return state.fmotc_mat},
    get_ftyp_offre: state => { return state.ftyp_offre},
    get_fmotc_cat: state => { return state.fmotc_cat},
    get_fmotc_cae: state => { return state.fmotc_cae},
    get_fmotc_caf: state => { return state.fmotc_caf},
    get_frech_lib: state => { return state.frech_lib},
    get_fgrp_col: state => { return state.fgrp_col},
    get_fmotc_cat_preselected: state => { return state.fmotc_cat_preselected},
    get_filter_tag: state => {return state.filter_tag},
    get_current_filter_tag_remove: state => {return state.current_filter_tag_remove },
    get_poffset: state => {return state.poffset },
    get_num_page: state => {return state.num_page },
    get_remove_tag_filter: state => {return state.remove_tag_filter},
};